import { render, staticRenderFns } from "./OtherContacts.vue?vue&type=template&id=ae533924&"
import script from "./OtherContacts.vue?vue&type=script&lang=js&"
export * from "./OtherContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports